'use client'

import { Category } from '@/payload-types'
import CategoryCard from './CategoryCard'
import React from 'react'
import classes from './index.module.css'
import { useTranslations } from 'next-intl'
import { SectionHeader } from '@/components/ui/SectionHeader'

import { cn } from '@/utilities/cn'

const ShopByCategories = ({ categories }: { categories: Category[] }) => {
  const t = useTranslations('product')
  const commonT = useTranslations('common')

  if (!categories || categories.length === 0) {
    return <div className={classes.noCategories}>{t('noCategories')}</div>
  }

  return (
    <div className="w-full max-w-[80rem] mx-auto my-3">
      <SectionHeader
        title={t('categories')}
        href="/shop"
        buttonLabel={commonT('viewAll')}
        testId="categories-title"
      />
      <section
        data-testid="shop-by-categories"
        className="w-full px-3 sm:px-5 lg:px-6 py-3 sm:py-4 lg:py-6 bg-white/5 dark:bg-black/20 backdrop-blur-2xl border border-white/20 rounded-2xl shadow-2xl transition-all duration-300 hover:bg-white/10 dark:hover:bg-black/30"
        style={{
          boxShadow:
            'inset 0 1px 0 rgba(255,255,255,0.15), inset 0 -40px 80px rgba(0,0,0,0.25), 0 8px 32px rgba(0,0,0,0.3)',
        }}
      >
        <div
          data-testid="categories-grid"
          className={cn(classes.bentoGrid, 'px-4 sm:px-6 lg:px-8 py-3 sm:py-4 lg:py-6')}
        >
          <span className={classes.gridDot} style={{ top: 'calc(200px + 6px)', left: '50%' }} />
          <span className={classes.gridDot} style={{ top: 'calc(400px + 18px)', left: '50%' }} />
          <span className={classes.gridDot} style={{ top: 'calc(400px + 18px)', left: '25%' }} />
          <span className={classes.gridDot} style={{ top: 'calc(400px + 18px)', right: '25%' }} />

          {categories.map((category, index) => (
            <CategoryCard key={index} category={category} index={index} />
          ))}
        </div>
      </section>
    </div>
  )
}

export default ShopByCategories

